import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { InfoState } from "@gemini/ui";
import { ExclamationCircleIcon } from "@gemini/icons";
import { useI18n } from "@/shared/hooks";
export const MapError = () => {
    const { t } = useI18n();
    return (_jsx(Box, { height: "100%", display: "flex", alignItems: "center", justifyContent: "center", children: _jsx(InfoState, { title: t("location.map.modal.error.title"), description: t("location.map.modal.error.description"), image: ExclamationCircleIcon }) }));
};
